import { createSlice } from "@reduxjs/toolkit";

const getRequestCashout = createSlice({
  name: "cashout",
  initialState: {
    data: [],
  },
  reducers: {
    setcashOut: (state, action) => {
      state.data = action.payload; // Update the value in the store
    },
    newCashout: (state, action) => {
      // console.log('payload in newCashout', action.payload);
      state.data.unshift(action.payload); // Update the value in the store
    },
  },
});

export const { setcashOut, newCashout } = getRequestCashout.actions;
export default getRequestCashout.reducer;